import { barShortLabels, maxCriteriaPills } from './constants'

export const getVisibleCriteriaNames = criteriaNames => {
  return {
    visibleNames: criteriaNames.slice(0, maxCriteriaPills),
    hiddenCount: Math.max(0, criteriaNames.length - maxCriteriaPills),
  }
}

export const getBarShortLabel = hiddenReasons => {
  const hasCriteria = hiddenReasons.criteriaNames.length > 0

  if (hiddenReasons.notActiveOn && hasCriteria) return barShortLabels.dateAndCriteria
  if (hiddenReasons.notActiveOn) return barShortLabels.date
  if (hasCriteria) return barShortLabels.criteria

  return null
}
